<template>
  <table class="statistic-significance" v-if="hasAllData">
    <thead>
      <tr>
        <th></th>
        <th
          class="statistic-significance__prop"
          v-for="(column, index) in keys"
          :key="index"
        >
          {{ getLetter(index) }}
        </th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(row, index) in keys" :key="index">
        <td
          class="statistic-significance__prop statistic-significance__prop_left"
        >
          {{ getLetter(index) }}
        </td>
        <td
          class="statistic-significance__value"
          :class="getClassValue(props.significance[row][column])"
          v-for="(column, columnKey) in keys"
          :key="columnKey"
        >
          {{ getValue(props.significance[row][column]) }}
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script setup>
import { computed, defineProps } from "vue";

const props = defineProps({
  significance: {
    type: Object,
    default: () => ({}),
  },
  statistic: {
    type: Array,
    default: () => [],
  },
});

const keys = computed(() => props.statistic.map(({ key }) => key));
const hasAllData = computed(() => {
  const significanceKeys = Object.keys(props.significance);
  return (
    keys.value.length &&
    significanceKeys.length &&
    keys.value.every((key) => significanceKeys.some((item) => item === key))
  );
});

const getLetter = (index) => {
  const letters = ["A", "B", "C", "D", "E", "F"];
  return letters[index] || letters[0];
};

const getValue = (value) => {
  if (value === true) {
    return "Y";
  } else if (value === false) {
    return "N";
  } else {
    return "-";
  }
};

const getClassValue = (value) => {
  if (value === true) {
    return "statistic-significance__value_green";
  } else if (value === false) {
    return "statistic-significance__value_red";
  } else {
    return "statistic-significance__value_grey";
  }
};
</script>

<style lang="scss" scoped>
.statistic-significance {
  width: 100%;
  border-collapse: separate;
  border-spacing: 4px;
  th,
  td {
    height: 24px;
    font-size: 12px;
    font-weight: 800;
    line-height: 20px;
    vertical-align: middle;
    text-align: center;
  }
  &__prop {
    border-radius: var(--Radius-border-radius-base, 4px);
    background: var(--Color-Fill-fill-color-lighter, #fafafa);
    color: var(--Color-Text-text-color-secondary, #909399);
    &_left {
      width: var(--Size-common-component-size-default, 32px);
    }
  }
  &__value {
    border-radius: var(--Radius-border-radius-base, 4px);
    &_green {
      background: var(--Color-Success-color-success-light-5, #b3e09c);
    }
    &_red {
      background: var(--Color-Error-color-error-light-5, #fab5b5);
    }
    &_grey {
      background: var(--Color-Info-color-info-light-5, #c7c9cc);
    }
  }
}
</style>
